import { render, staticRenderFns } from "./StaffArchivedPageTableControl.vue?vue&type=template&id=d419a6a4&scoped=true&"
import script from "./StaffArchivedPageTableControl.vue?vue&type=script&lang=js&"
export * from "./StaffArchivedPageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d419a6a4",
  null
  
)

export default component.exports